module.exports = __webpack_public_path__ + "img/icone-configuracao.7f4b2635.svg";